import LegalPage from './LegalPage'

export default function Regulamin() {
  return <LegalPage tab="regulamin" />
}
